export type NewsType = 'news' | 'campaigns';

export class News {
  id?: string;
  title?: string;
  description?: string;
  /** Cuerpo en formato markdown (editor tipo wiki) */
  content?: string;
  image?: string;
  /** Posición/foco CSS de la imagen (ej: "center top", "center 25%", "center") */
  imageFocus?: string;
  /** Tags separados por comas (ej: "beliv,agua,salutaris") */
  tags?: string;
  type?: NewsType | string;
  status?: string;
  createdAt?: string;
  createdBy?: string;
}

export class NewsDTO extends News {}

/**
 * Foco de imagen: centro (x,y en %) + zoom (z). Se guarda en News.imageFocus
 * como JSON. Tolera valores antiguos (ej. "center") devolviendo el centro.
 */
export interface NewsFocus {
  x: number;
  y: number;
  z: number;
}

export function parseNewsFocus(imageFocus?: string): NewsFocus {
  const def: NewsFocus = { x: 50, y: 50, z: 1 };
  if (!imageFocus) return def;
  try {
    const o = JSON.parse(imageFocus);
    if (o && typeof o.x === 'number' && typeof o.y === 'number') {
      return { x: o.x, y: o.y, z: typeof o.z === 'number' && o.z > 0 ? o.z : 1 };
    }
  } catch {
    // valores viejos tipo "center"/"center top" → centro por defecto
  }
  return def;
}

/** Posición CSS (object-position/background-position) a partir del foco */
export function newsFocusPosition(imageFocus?: string): string {
  const f = parseNewsFocus(imageFocus);
  return `${f.x}% ${f.y}%`;
}

/** Factor de zoom (scale) a partir del foco */
export function newsFocusZoom(imageFocus?: string): number {
  return parseNewsFocus(imageFocus).z;
}
